export default __webpack_public_path__ + "static/second-place-a33eda24164fa946f394689670deb53f.png";